/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import { Button, Col, Form, Input, notification, Row } from 'antd';
import { useMutation } from '@tanstack/react-query';
import { ICustomer } from '@/interfaces/customer';
import { editCustomer } from '@/adapters/customer';

interface IProps {
  data: ICustomer;
  handleOk: () => void;
  handleCancel: () => void;
}

const CustomerRemarkEdit = ({ data, handleOk, handleCancel }: IProps) => {
  const [form] = Form.useForm<Partial<ICustomer>>();
  const mutations = useMutation({
    mutationFn: async (data: Partial<ICustomer>) => await editCustomer(data),
    mutationKey: ['editCustomer'],
    onSuccess: data => {
      if (data?.status != 200) {
        throw new Error();
      } else {
        notification.success({
          message: 'อัพเดทบันทึกช่วยจำสำเร็จ',
        });
        handleOk();
      }
    },
    onError: error => {
      console.log(error);
    },
  });

  const handleUpdate = async () => {
    form
      .validateFields()
      .then(async (values: Partial<ICustomer>) => {
        data.remark = values.remark;
        data.whRemark = values.whRemark;
        data.logisticRemark = values.logisticRemark;
        data.billingRemark = values.billingRemark;
        await mutations.mutateAsync(data);
      })
      .catch(info => {
        console.log('Validate Failed:', info);
      });
  };

  const onReset = () => {
    form.resetFields();
  };

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        ...data,
      });
    }
    return () => {
      onReset();
    };
  }, [data]);

  return (
    <div className="flex w-full">
      <Form
        form={form}
        name="customerRemark"
        onFinish={handleUpdate}
        layout="vertical"
        className="w-full"
        autoComplete="off"
      >
        <Row gutter={12}>
          <Col span={24}>
            <Form.Item label="หมายเหตุ" name="remark">
              <Input.TextArea rows={2} size="large" autoComplete="nope" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="หมายเหตุ (คลัง)" name="whRemark">
              <Input.TextArea rows={2} size="large" autoComplete="nope" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="หมายเหตุ (ขนส่ง)" name="logisticRemark">
              <Input.TextArea rows={2} size="large" autoComplete="nope" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="หมายเหตุ (วางบิล)" name="billingRemark">
              <Input.TextArea rows={2} size="large" autoComplete="nope" />
            </Form.Item>
          </Col>
        </Row>
        <div className="flex flex-row justify-end gap-3">
          <Button key="back" onClick={handleCancel}>
            ยกเลิก
          </Button>
          <Button
            key="submit"
            type="primary"
            form="customerRemark"
            loading={mutations.isPending}
            onClick={handleUpdate}
          >
            บันทึก
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default CustomerRemarkEdit;
